import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavController, NavParams } from '@ionic/angular';
import { LocaldataService } from '../../service/localdata/localdata.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent{

  private flatdata;
  private folderDepth:number;

  constructor(public navCtrl: NavController, public localData: LocaldataService, private router: Router) {
    this.flatdata = localData.folderStructure;
  }

  navigateBreadcrumb(obj){    const arrayObj = this.localData.breadcrumb.findIndex(x => x.id === obj.id)+1;
    this.localData.breadcrumb.splice(arrayObj,this.localData.breadcrumb.length);
    this.router.navigate(['dueslag', obj.id]) ;
  }

  navigateBreadcrumbRoot(){
    this.localData.breadcrumb.splice(0,this.localData.breadcrumb.length);
    this.router.navigate(['dueslag']) ;
  }

}